import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './About.css';

const About = () => {
  const [content, setContent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAboutContent = async () => {
      try {
        const response = await axios.get('/api/pages/about');
        setContent(response.data);
      } catch (err) {
        console.error('Error loading about page:', err);
        setError('Failed to load about page content');
      } finally {
        setLoading(false);
      }
    };

    fetchAboutContent();
  }, []);

  if (loading) {
    return (
      <div className="about">
        <div className="about-container">
          <div className="loading">Loading...</div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="about">
        <div className="about-container">
          <div className="error">{error}</div>
        </div>
      </div>
    );
  }

  return (
    <div className="about">
      <div className="about-container">
        <div dangerouslySetInnerHTML={{ __html: content.content }} />
      </div>
    </div>
  );
};

export default About;